import React from 'react';
import { Link } from 'react-router-dom';
// import logout from '../Components/Image/logout.png'
// import Sidebar from '../Components/Sidebar';
// import { Button } from 'react-bootstrap';
import TableComp from '../Components/ReusableTable'
// import Carousel from '../Components/Carousel.js';
import { connect } from 'react-redux'
import { getSupplierPOs } from '../store/actions/supplierActions'
import SearchBar from '../Components/SearchBar';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import AuthHandlerInstance from '../Classes/AuthHandler'
import numberWithCommas from '../Classes/NumberwithComma'
import dateFormater from '../Classes/FormatDate'
import Loading from '../Components/Loader'
import { GetPOLineItemsForSameTemplate, GetSameTemplateDetilsByPolineiTemId, requestForVendorApproval, UpdateDocIdForMultipleStagesByPOLineItemId, GetDocumentsForQA, getQADocumentsByParams, postQADocumentForPOLineitemID } from '../store/actions/poDetailsActions'
import { uploadFile, uploadVersionFile, uploadFileGeneric } from '../store/actions/fileActions.js'
import { GetAllPoLineItemsByPoId, postDocumentDetailsForExpediting } from '../store/actions/expediting.Actions'
import Modal from '../Components/CustomModal'
import ModalHeader from '../Components/ModalHeader'
import ModalBody from '../Components/ModalBody'
import ModalFooter from '../Components/ModalFooter'
import swal from 'sweetalert';

import toast from 'react-hot-toast';
import ManufacturingClearence from '../Components/Manufacturing_Clearence';
import env from '../ENV';




const FILESERVER_ROOT_URL = env.FILE_SERVER_URL;

class Dashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      supplierName: "",
      tableData: [],
      tableData1: [],
      searchInput: "",
      loading: false,
      openUploadModal: false,
      openUploadSameDocModal: false,
      loadingUpload: false,
      uploadDataForMultiple: [],
      select: false,
      Manufacturing_Clearence: false,
      selected: [],
      DrawingArray: [{
        Name: "",
        file: "",
        typeId: 86
      }],
      ProgressArray: [{
        Name: "",
        file: "",
        typeId: 102
      }],
      ExpDocArray: [
        {
          Name: "QA Plan",
          file: "",
          typeId: 88
        },
        {
          Name: "Delivery Schedule",
          file: "",
          typeId: 99
        }
      ],
      filesArray: [],
      varId: "",
      searchButton: false,
      uploadedfile: false,
      uploadedId: "",
      selectedFile: {},
      files: {},
      selectedfilestageId: [],
      stageIds: [],
      document: '',
      qaDocumentFile: '',
      documentFile: '',

    }
    this.handleDataLoading = this.handleDataLoading.bind(this)
    this.openUploadModal = this.openUploadModal.bind(this);
    this.openUploadSameDocModal = this.openUploadSameDocModal.bind(this);
    this.Manufacturing_Clearence = this.Manufacturing_Clearence.bind(this);
  }
  componentDidMount() {

    this.handleDataLoading()

  }

  handleDataLoading = async () => {
    await this.setState({ loading: true, loadingUpload: true })
    let poId = this.props.location.state.poId
    console.log(poId, "oooooo")
    var userId = AuthHandlerInstance.getUserID()
    await this.props.getSupplierPOs(userId, '', poId)
    await this.props.GetAllPoLineItemsByPoId(poId)
    await this.props.GetPOLineItemsForSameTemplate(poId)
    await this.props.GetDocumentsForQA()
    let tableData1 = []
    let tableData2 = []
    let dataArray = []
    tableData1 = await this.props.poDetails.getPOLineItemsForSameTemplate.PoLineItemArray
    console.log(tableData1, "tableData1")

    let uploadDataForMultiple = await this.props.expediting.getAllPoLineItems.recordset.filter((item) => item.DeliverySchedule === null && item.QAPlan === null)

    await this.setState({
      tableData1, tableData2,
      tableData: this.props.supplier.pos, loading: false,
      uploadDataForMultiple: uploadDataForMultiple, loadingUpload: false,
    })
    console.log(this.props.supplier.pos)
    if (this.props.supplier.pos[0]) {
      this.setState({ supplierName: this.props.supplier.pos[0].VendorName })
    } else {
      this.setState({ supplierName: "" })
    }
  }

  // ? handle search input
  handleISearch = (e) => {
    let searchInput = e.target.value
    this.setState({
      searchInput
    })
    console.log(this.state.searchInput)
  }

  // ? handle searching
  handleSearching = async () => {
    await this.setState({ loading: true })
    var userId = AuthHandlerInstance.getUserID()
    let searchTerm = this.state.searchInput
    await this.props.getSupplierPOs(userId, searchTerm)
    console.log("Search complete, results are : ", this.props.supplier.pos)
    await this.setState({ tableData: this.props.supplier.pos, searchInput: "", loading: true })

  }
  openUploadModal() {
    this.setState({ openUploadModal: !this.state.openUploadModal });
    if (this.state.openUploadModal === true) {
      this.setState(
        { opacity: "" }
      )
    }
    else {
      this.setState(
        { opacity: "0.2" }
      )
    }
  }
  openUploadSameDocModal() {
    this.setState({ openUploadSameDocModal: !this.state.openUploadSameDocModal });
    if (this.state.openUploadSameDocModal == true) {
      this.setState(
        { opacity: "" }
      )
    }
    else {
      this.setState(
        { opacity: "0.2" }
      )
    }
  }

  handleSingleCheckboxChange = async (index) => {
    let selected = [...this.state.selected];
    let select = ''
    if (!selected.includes(index)) {
      selected.push(index)
    } else {
      selected = selected.filter((e) => e !== index)
      select = false
    }
    if (select === false) {
      this.setState({ select })
    }
    await this.setState({ selected });
    console.log(this.state.selected, "ppppp")
  };

  handleChange = () => {
    try {
      let selected = [];
      let select = !this.state.select;
      console.log(select, '??????////')
      this.state.uploadDataForMultiple.map((item, index) => {
        if (select === true) {
          selected.push(item.PurchaseOrderLineId)
        }
        return item
      });
      this.setState({ selected: selected, select: select });
    } catch (e) {
      console.log(e);
    }
  };
  handleAllChange = () => {
    try {
      let selected = [];
      let select = !this.state.select;
      this.state.uploadDataForMultiple.map((item, index) => {
        if (select == true) {
          selected.push(item.PurchaseOrderLineId)
        }
      });
      this.setState({ selected: selected, select: select });
      console.log(selected, "selected")
    } catch (e) {
      console.log(e);
    }
  };

  OnDrawingCHange = async (item, index, event) => {
    console.log(index)
    let DrawingArray = []
    await this.state.DrawingArray.map((elem, i) => {
      var temObj = elem
      if (i === index) {
        temObj.Name = event.target.value
      }
      DrawingArray.push(temObj)
      return elem
    })
    await this.setState({ DrawingArray })
  }
  OnProgressReportCHange = async (item, index, event) => {
    console.log(index)
    let ProgressArray = []
    await this.state.ProgressArray.map((elem, i) => {
      var temObj = elem
      if (i === index) {
        temObj.Name = event.target.value
      }
      ProgressArray.push(temObj)
      return elem
    })
    await this.setState({ ProgressArray })
  }
  OnExDocCHange = async (item, index, event) => {
    console.log(index)
    let ExpDocArray = []
    await this.state.ExpDocArray.map((elem, i) => {
      var temObj = elem
      if (i === index) {
        temObj.Name = event.target.value
      }
      ExpDocArray.push(temObj)
      return elem
    })
    await this.setState({ ExpDocArray })
  }

  addDrawings = async () => {
    let DrawingArray = [...this.state.DrawingArray]
    DrawingArray.push(
      {
        Name: "",
        file: "",
        typeId: 86
      }
    )
    await this.setState({ DrawingArray })
  }
  removeDrawings = async (item, index) => {
    let DrawingArray = [...this.state.DrawingArray]
    DrawingArray = DrawingArray.filter((item, i) => i !== index)

    let filesArray = [...this.state.filesArray]
    filesArray = filesArray.filter((elem, i) => elem.index !== index && item.typeId !== elem.typeId)

    await this.setState({ DrawingArray, filesArray })
  }
  addProgressReport = async () => {
    let ProgressArray = [...this.state.ProgressArray]
    ProgressArray.push(
      {
        Name: "",
        file: "",
        typeId: 102
      }
    )
    await this.setState({ ProgressArray })
  }
  removeProgressReport = async (item, index) => {
    let ProgressArray = [...this.state.ProgressArray]
    ProgressArray = ProgressArray.filter((item, i) => i !== index)

    let filesArray = [...this.state.filesArray]
    filesArray = filesArray.filter((elem, i) => elem.index !== index && item.typeId !== elem.typeId)

    await this.setState({ ProgressArray, filesArray })
  }
  handleFile = async (item, index, e) => {
    let filesArray = [...this.state.filesArray]
    let tempArray = []
    if (filesArray.length > 0) {
      if (filesArray.find((elem) => elem.index === index && item.typeId === elem.typeId)) {
        filesArray.map((elem) => {
          var tempObj = elem
          if (elem.index === index && item.typeId === elem.typeId) {
            tempObj.file = e.target.files[0]
          }
          tempArray.push(tempObj)
          return elem
        })
      } else {
        filesArray.map((elem, i) => {
          var tempObj = elem
          tempArray.push(tempObj)
          return elem
        })
        tempArray.push({
          "index": index,
          "typeId": item.typeId,
          "file": e.target.files[0],
        })
      }
    }
    else {
      tempArray.push({
        "index": index,
        "typeId": item.typeId,
        "file": e.target.files[0],
      })
    }
    await this.setState({ filesArray: tempArray })
    console.log(this.state.filesArray, "this.state.filesArray")
  }

  ExpDocSubmit = async () => {
    if (this.state.selected.length === 0) {
      swal("Please Select a Line Item", { icon: "error", button: true })
      return false
    }
    if (this.state.filesArray.length === 0) {
      swal("Please Choose a file", { icon: "error", button: true })
      return false
    }
    let exist = false
    let item = {}
    await this.state.filesArray.map((elem) => {
      if (elem.typeId === 86) {
        item = this.state.DrawingArray.find((e, i) => i === elem.index)
        if (item.Name === "") {
          exist = true
        }
      }
      else if (elem.typeId === 102) {
        item = this.state.ProgressArray.find((e, i) => i === elem.index)
        if (item.Name === "") {
          exist = true
        }
      }
      return elem
    })
    console.log(exist, "exist")
    if (exist) {
      swal("Please Enter a Documet Name for Choosen files", { icon: "error", button: true })
      return false
    }
    let result = []
    console.log(this.state.filesArray, "IIIIIIIIIIIIIIIIIIIIIIIIIIII")
    await this.state.filesArray.map(async (elem) => {
      await this.props.uploadFileGeneric([elem.file], AuthHandlerInstance.getUserID())
        .then(async (results) => {
          await result.push({
            res: results.results[0],
            typeId: elem.typeId,
            index: elem.index
          })
          await this.state.selected.map(async (element) => {
            if (elem.typeId === 86) {
              let item = await this.state.DrawingArray.find((e, i) => i === elem.index)
              await this.props.postDocumentDetailsForExpediting({
                DocumentId: results.results[0].DocumentId,
                DocumentTypeId: elem.typeId,
                POId: this.state.tableData[0].PurchaseOrderId,
                PoLineItemId: element,
                DrawingDocumentDetailsid: 0,
                approvalStatus: 0,
                DocumentTypeName: item.Name,

              })
            }
            else if (elem.typeId === 102) {
              let item = await this.state.ProgressArray.find((e, i) => i === elem.index)
              await this.props.postDocumentDetailsForExpediting({
                DocumentId: results.results[0].DocumentId,
                DocumentTypeId: elem.typeId,
                POId: this.state.tableData[0].PurchaseOrderId,
                PoLineItemId: element,
                DrawingDocumentDetailsid: 0,
                approvalStatus: 0,
                DocumentTypeName: item.Name,
              })
            }
            else {
              await this.props.postDocumentDetailsForExpediting({
                DocumentId: results.results[0].DocumentId,
                DocumentTypeId: elem.typeId,
                POId: this.state.tableData[0].PurchaseOrderId,
                PoLineItemId: element,
                DrawingDocumentDetailsid: 0,
                approvalStatus: 0
              })
            }
          })
          console.log(result, 'results')
        })
    })
    console.log(result, "IIIIIIIIIIIIIIIIIIIIIIIIIIII")
    console.log(this.state.selected, "IIIIIIIIIIIIIIIIIIIIIIIIIIII")
    console.log(result, "IIIIIIIIIIIIIIIIIIIIIIIIIIII")
    await this.openUploadModal()
    await this.openUploadSameDocModal()
    await this.handleDataLoading()
  }
  rowClick = async (data) => {
    console.log(data, "idddd")
    let id = data.PurchaseOrderLineId
    await this.setState({ varId: id })
    await this.Manufacturing_Clearence()
  }
  Manufacturing_Clearence() {
    this.setState({ Manufacturing_Clearence: !this.state.Manufacturing_Clearence });
    this.setState({ RetentionDocumentsModal: false });
    if (this.state.Manufacturing_Clearence === true) {
      this.setState(
        { opacity: "" }
      )
    }
    else {
      this.setState(
        { opacity: "0.2" }
      )
    }
  }

  toggleManufacturing_Clearence = async (e) => {
    await this.setState({ Manufacturing_Clearence: !this.state.Manufacturing_Clearence });
    if (this.state.Manufacturing_Clearence === true) {
      this.setState(
        { opacity: "" }
      )
    }
    else {
      this.setState(
        { opacity: "0.2", varId: "" }
      )
    }
  }
  searchSimilarTemp = async () => {
    await this.setState({ searchButton: true })
    if (this.state.selected.length == 0) {
      return false;
    }
    let val = (this.state.selected).join(',')
    await this.props.GetSameTemplateDetilsByPolineiTemId(this.state.selected)
    let tableData2 = await this.props.poDetails.getSameTemplate
    // if (tableData2.length == 0) {
    //   swal("No Similar Documents Present", { icon: "error", button: true })
    // }
    // else {
    //   swal(tableData2[0].DocumentTypeName + " Is the Similar Document", { icon: "success", button: true })
    // }
    console.log(val, tableData2, "selectedselected")
    this.setState({ tableData2 })
  }

  handleFileInput = (event) => {
    let input = event.target.files[0]
    console.log(input, "Data=======")
    this.setState({ selectedFile: input })
  }
  uploadMultipleDoc = async (data) => {
    console.log(data, this.state.selectedFile, "Data=======")
    if (this.state.selectedFile.length < 1) {
      swal("Please upload some valid document", { icon: "error" })
      return false;
    }
    toast.loading('Uploading Files...', {
      duration: 1000
    });
    var result = await this.props.uploadFileGeneric([this.state.selectedFile], AuthHandlerInstance.getUserID())
    var documentId = result.results[0].DocumentId
    console.log(result, "Data=======")
    await this.state.selected.map(async (elem) => {
      let input = {
        PolIneiTemId: elem,
        DocumentTypeId: data.DocumentTypeId,
        StageId: data.StageId,
        UploadId: documentId
      }
      await this.props.UpdateDocIdForMultipleStagesByPOLineItemId(input)
    })

  }

  handleDocument = async (e) => {
    this.setState({ document: e.target.value })
  }

  handleDocumentFileInput = async (e) => {
    this.setState({ documentFile: e.target.files[0] })
  }

  submitDocument = async () => {
    if (this.state.document == '') {
      swal("Please select document", { icon: "error", button: true })
      return false;
    }
    if (this.state.documentFile == '') {
      swal("Please upload some file", { icon: "error", button: true })
      return false;
    }
    var result = await this.props.uploadFileGeneric([this.state.documentFile], AuthHandlerInstance.getUserID())
    var versionId = result.results[0].VersionId
    var documentId = result.results[0].DocumentId

    await this.state.selected.map(async (elem) => {
      await this.props.postQADocumentForPOLineitemID({
        DocumentTypeId: this.state.document,
        DocumentId: documentId,
        VersionId: versionId,
        ActedBy: AuthHandlerInstance.getUserID(),
        PurchaseOrderId: this.props.location.state.poId,
        PurchaseOrderLineId: elem,
      })
    });
    await this.setState({ documentFile: '', document: '', selected: [] });

    await this.handleDataLoading()
  }

  render() {
    var varId = this.state.varId
    console.log(this.props.location.state.poId, "OOOOO")
    // this.props.supplier.pos && this.setState({ supplierName: this.props.supplier.pos[0].VendorName })

    // ? on button click of table function
    const handleClickTableButton = (item) => () => {
      // write your logic
      alert(JSON.stringify(item))
    }

    // ? table column headers
    const tableConstants = (handleEdit) => {
      return [
        {
          title: 'PO Item',
          render: rowData => {
            return <span>{rowData.POLineItemSAPCode}</span>;
          },
        },
        {
          title: 'Created On',
          render: rowData => {
            return <span>{dateFormater(rowData.POCreationDate)}</span>;
          },
        },
        {
          title: 'PO Amount',
          render: rowData => {
            return <div className="amount-text"><span >{rowData.POLineItemAmount ? numberWithCommas(rowData.POLineItemAmount) : "NA"}</span></div>;
          },
        },
        {
          title: 'PO Line Item Quantity',
          render: rowData => {
            return <div className="amount-text"><span >{rowData.POLineItemQuantity ? (numberWithCommas(rowData.POLineItemQuantity) + ' ' + rowData.OrderUnit) : "NA"}</span></div>;
          },
        },
        {
          title: 'Location',
          render: rowData => {
            return <span>{rowData.Location}</span>;
          },
        },
        {
          title: 'Deletion Indicator',
          render: rowData => {
            return <span>{rowData.DeletionIndicator ? rowData.DeletionIndicator : '--'}</span>;
          },
        },
        {
          title: 'Manufacturing Status',
          render: rowData => {
            return (<><span className={rowData.isHold === 1 ? 'badge badge-warning' : rowData.ManufacturingClearence ? 'badge badge-success' : ''}>{rowData.isHold === 1 ? 'Hold' : rowData.ManufacturingClearence ? 'Manufacturing Clearence issued' : '--'}</span>
              <div className="row justify-content-md-center mt-2">
                <div className="col">
                  <FontAwesomeIcon icon={"sms"} color={"black"} title="View" size="lg" onClick={() => this.rowClick(rowData)} />
                </div>
              </div></>);
          },
        },
        {
          title: 'QA Status',
          render: rowData => {
            return <span>{rowData.Status}</span>;
          },
        },
        {
          title: 'Expediting Status',
          render: rowData => {
            return <span>{rowData.PartialApproval === 1 ?
              `Document ${rowData.DocumentName} Partially Approved`
              : rowData.DrawingDocumentTypeId === 86 && rowData.DrawingStatus === 0 ?
                `Document ${rowData.DocumentName} Submitted`
                : rowData.DrawingDocumentTypeId === 86 && rowData.DrawingStatus === 1 ?
                  `Document ${rowData.DocumentName} Approved`
                  : rowData.DrawingDocumentTypeId === 86 && rowData.DrawingStatus === 4 ?
                    `Document ${rowData.DocumentName} is in Progress`
                    : rowData.DrawingDocumentTypeId !== 86 && rowData.DrawingStatus === 0 && rowData.DrawingDocId ?
                      `Document ${rowData.DocumentName} is Submitted`
                      : null
            }</span>;
          },
        },
        {
          title: 'Actions',
          render: rowData => {
            return (
              <div className="view-button">
                <Link className="pr-2" to={{ pathname: '/ExpeditingPOAcceptanceTrail', state: { poId: rowData.PurchaseOrderId, POSAPId: rowData.POSAPId, lineItemID: rowData.PurchaseOrderLineId, lineItemSAPId: rowData.POLineItemSAPCode } }}>
                  <FontAwesomeIcon icon={"sign-in-alt"} color="black" title="View Line Item Trail" size="lg" />
                </Link>
                {rowData.TrnStatusName === 'PO Approved' ? <Link to={{ pathname: '/InspectiondashboardDocument', state: { poid: rowData.POSAPId, itemNo: rowData.POLineItemSAPCode, po: rowData.PurchaseOrderId, polineitemID: rowData.PurchaseOrderLineId, status: rowData.Status } }}>
                  <FontAwesomeIcon icon={"eye"} title="View" color={"black"} size="lg" />
                </Link> :
                  <Link>
                    <FontAwesomeIcon icon={"eye"} title="View" color={"grey"} size="lg" />
                  </Link>
                }
              </div>

            )
          },
        },
      ];
    };

    // ? table column headers
    const UploadTableConstant = () => {
      return [
        {
          title: <input type="checkbox" name="checked" onClick={this.handleChange} checked={this.state.select} />,
          render: rowData => {
            return (
              <div>
                <input type="checkbox" name="checked" checked={this.state.selected.includes(rowData.PurchaseOrderLineId) ? true : false} value="" onChange={(event) => this.handleSingleCheckboxChange(rowData.PurchaseOrderLineId)} />
              </div>
            );
          },
        },
        {
          title: 'PO Item',
          render: rowData => {
            return <span>{rowData.POLineItemSAPCode}</span>;
          },
        },
        {
          title: 'PO Item Amount',
          render: rowData => {
            return <span>{rowData.POLineItemAmount}</span>;
          },
        },
        {
          title: 'Currency',
          render: rowData => {
            return <span>{rowData.Currency}</span>;
          },
        },
        {
          title: 'PO Item Quantity',
          render: rowData => {
            return <span>{rowData.POLineItemQuantity}</span>;
          },
        },
        {
          title: 'Unit',
          render: rowData => {
            return <span>{rowData.OrderUnit}</span>;
          },
        },
      ];
    };
    // ? table column headers
    const DrawingTable = () => {
      return [
        {
          title: 'Drawing Name',
          render: (rowData, index) => {
            return <input type="text" value={rowData.Name} onChange={(e) => this.OnDrawingCHange(rowData, index, e)} />;
          },
        },
        {
          title: 'Document',
          render: (rowData, index) => {
            return <input type="file" onChange={(e) => this.handleFile(rowData, index, e)} />
          },
        },
        {
          title: 'Action',
          render: (rowData, index) => {
            if (index === 0) {
              return <button className="btn2 btn-sms1" onClick={() => this.addDrawings()}>ADD</button>;
            }
            else {
              return <button className="btn2 btn-sms1" onClick={() => this.removeDrawings(rowData, index)}>Remove</button>;
            }
          },
        },
      ];
    };
    // ? table column headers
    const ProgressReport = () => {
      return [
        {
          title: 'Document Name',
          render: (rowData, index) => {
            return <input type="text" value={rowData.Name} onChange={(e) => this.OnProgressReportCHange(rowData, index, e)} />;
          },
        },
        {
          title: 'Document',
          render: (rowData, index) => {
            return <input type="file" onChange={(e) => this.handleFile(rowData, index, e)} />
          },
        },
        {
          title: 'Action',
          render: (rowData, index) => {
            if (index === 0) {
              return <button className="btn2 btn-sms1" onClick={() => this.addProgressReport()}>ADD</button>;
            }
            else {
              return <button className="btn2 btn-sms1" onClick={() => this.removeProgressReport(rowData, index)}>Remove</button>;
            }
          },
        },
      ];
    };
    // ? table column headers
    const ExpDoc = () => {
      return [
        {
          title: 'Document Name',
          render: (rowData, index) => {
            return <span>{rowData.Name}</span>;
          },
        },
        {
          title: 'Document',
          render: (rowData, index) => {
            return <input type="file" onChange={(e) => this.handleFile(rowData, index, e)} />
          },
        },
      ];
    };

    if (!this.state.tableData.length) {

      return (
        <Loading />
      )
    }

    return (

      <div className="Container-fluid p-4" >
        {/* ----Modal Start----- */}

        <Modal isOpen={this.state.openUploadModal} >
          <div className={"modal-bg" + (this.state.openUploadModal === 'false' ? 'open' : '')}>
            <div className="modalheads">
              <ModalHeader HeaderStyle="modal-header modalHeadersWideUpload ">
                <div><h4 >Upload Documents</h4></div>
                <button type="button" className="close" aria-label="Close" onClick={this.openUploadModal} >
                  <span aria-hidden="true">&times;</span>
                </button>
              </ModalHeader>
            </div>

            <div >
              <ModalBody Style="modal-body modalbodysWideUpload modalbodys">
                <div className="row">
                  <div className="col pt-4 centre-alligned">
                    {this.state.loadingUpload ?
                      <Loading />
                      :
                      <TableComp cols={UploadTableConstant()} data={this.state.uploadDataForMultiple} />
                    }
                  </div>
                </div>
                <hr></hr>
                <div className="row">
                  <div className="col"><h4>Drawing Doucuments: </h4></div>
                </div>
                <div className="row">
                  <div className="col">
                    <TableComp cols={DrawingTable()} data={this.state.DrawingArray} />
                  </div>
                </div>
                <hr></hr>
                <div className="row">
                  <div className="col"><h4>All Documents: </h4></div>
                </div>
                <div className="row">
                  <div className="col">
                    <TableComp cols={ExpDoc()} data={this.state.ExpDocArray} />
                  </div>
                </div>
                <hr></hr>
                <div className="row">
                  <div className="col"><h4>Progress Report: </h4></div>
                </div>
                <div className="row">
                  <div className="col">
                    <TableComp cols={ProgressReport()} data={this.state.ProgressArray} />
                  </div>
                </div>
              </ModalBody>
            </div>
            <div>
              <ModalFooter FooterStyle="modal-footer modalFootersWideUpload">
                <div>
                  <button className="btn2 btn-sms1 mt-2 ml-4 float-right" onClick={() => this.ExpDocSubmit()} type="submit">Save & Upload</button>
                  <button type="button" className="btn2 btn-sms1 mt-2 float-right" onClick={this.openUploadModal}> Cancel </button>
                </div>
              </ModalFooter>
            </div>
          </div>
        </Modal>
        {/*----------Document comment-------------- */}
        {
          varId ? (<ManufacturingClearence action={this.state.Manufacturing_Clearence} toggleManufacturing_Clearence={(e) => this.toggleManufacturing_Clearence(e)} PoLineId={varId} />) : null
        }
        {/*----------Document Comment end  */}

        {/* ----Modal End-------- */}
        <Modal isOpen={this.state.openUploadSameDocModal} >
          <div className={"modal-bg" + (this.state.openUploadSameDocModal === 'false' ? 'open' : '')}>
            <div className="modalheads">
              <ModalHeader HeaderStyle="modal-header modalHeadersWideUpload ">
                <div><h4 >Common Documents</h4></div>
                <button type="button" className="close" aria-label="Close" onClick={this.openUploadSameDocModal} >
                  <span aria-hidden="true">&times;</span>
                </button>
              </ModalHeader>
            </div>

            <div >
              <ModalBody Style="modal-body modalbodysWideUpload modalbodys">
                <div className="row">
                  {/* <button type="button" className="btn2 btn-sms1 mt-2 float-right" style={{ marginLeft: 900 }} onClick={() => this.searchSimilarTemp()}>Search</button> */}
                  <div className="col pt-4 centre-alligned">
                    {this.state.loadingUpload ?
                      <Loading />
                      :
                      <div className="row sticky ">
                        <div className="col wrap  ">
                          <table class="table table-bordered mt-4">
                            <thead class="table sticky-inner" style={{ backgroundColor: "#0989CB", color: "white" }}>
                              <tr>
                                <th scope="col"><input type="checkbox" name="checked" onClick={this.handleAllChange} checked={this.state.select} /></th>
                                <th scope="col">PurchaseOrderLineId</th>
                                <th scope="col" style={{ minWidth: '150px' }}>POLineItemSAPCode</th>
                                <th scope="col">POLineItemAmount</th>
                                <th scope="col" style={{ minWidth: '150px' }}>POLineItemQuantity</th>
                                <th scope="col">POLineItemDescription</th>
                              </tr>
                            </thead>
                            <tbody>
                              {
                                this.state.uploadDataForMultiple.map((item, index) => {
                                  return (
                                    <>
                                      <tr>
                                        <td><input type="checkbox" name="checked" checked={this.state.selected.includes(item.PurchaseOrderLineId) ? true : false} value="" onChange={(event) => this.handleSingleCheckboxChange(item.PurchaseOrderLineId)} onClick={() => this.searchSimilarTemp()} /></td>
                                        <td>{item.PurchaseOrderLineId}</td>
                                        <td>{item.POLineItemSAPCode}</td>
                                        <td>{item.POLineItemAmount}</td>
                                        <td>{item.POLineItemQuantity}</td>
                                        <td>{item.POLineItemDescription}</td>
                                      </tr>
                                    </>
                                  )
                                })

                              }
                            </tbody>
                          </table>
                        </div>
                      </div>
                    }
                  </div>
                  {
                    this.state.selected.length ?
                      <>
                        {this.state.tableData2.length == 0 ? <div> No Similar Documents Present </div> : null}
                        <div className="col-12">
                          <div className="row">
                            <div className="col form-group">
                              <select className='form-control' onChange={(e) => { this.handleDocument(e) }}>
                                <option disabled selected>Select Document</option>
                                {this.props.qaDocuments.map((document) => {
                                  return <option value={document.DocumentTypeId}>{document.DocumentTypeName}</option>
                                })}
                              </select>
                            </div>
                            <div className='col form-group'>
                              <input type="file" className="form-control-file" style={{ width: "79%", float: "rigth" }} accept=".pdf" onChange={(e) => { this.handleDocumentFileInput(e) }} id="exampleFormControlFile1" />
                            </div>
                            <div className='col form-group'>
                              <button className="btn2 btn-sms1 rounded-pill" onClick={() => this.submitDocument()} type="submit">Submit</button>
                            </div>
                          </div>
                        </div>
                        {this.state.tableData2.map((item, index) =>
                          <div className='row' style={{ margin: 10 }} >
                            <div className='col'>
                              {item.DocumentTypeName}
                            </div>
                            {item.UploadId == 0 || item.Status > 3 ?
                              <>
                                <div className='col-7' >
                                  <input type="file" class="form-control-file" onChange={(e) => this.handleFileInput(e)} style={{ width: "79%", float: "rigth" }} accept=".pdf" id="exampleFormControlFile1" />
                                </div>
                                <div className='col-1'>
                                  <button type="button" className="btn2 btn-sms1 mt-2" onClick={() => this.uploadMultipleDoc(item)}>Upload</button>
                                </div>
                              </>
                              : <a href={FILESERVER_ROOT_URL + "files/Documents/" + item.UploadId + "/download"} target="_blank" download>
                                <FontAwesomeIcon className="align-middle mt-2 pr-2" style={{ marginLeft: "10px", marginRight: "5px" }} icon={"download"} color={"black"} title="Download" size="2x" />
                              </a>
                            }
                          </div>
                        )}
                      </>
                      : null
                  }
                </div>
                <hr></hr>
              </ModalBody>
            </div>
            <div>
              <ModalFooter FooterStyle="modal-footer modalFootersWideUpload">
                <div>
                  <button type="button" className="btn2 btn-sms1 mt-2 float-right" onClick={this.openUploadSameDocModal}> Cancel </button>
                </div>
              </ModalFooter>
            </div>
          </div>
        </Modal>
        <div className="row " >
          <div className="col-md-4 header">
            <b>{this.state.supplierName}</b>
            <h4>PO Number : {this.state.tableData[0].POSAPId}</h4>
          </div>
          <div className="col-md-4 ">
            <Link to={{ pathname: '/Supplier/RequestInspection', state: {} }}>
              <button className="btn2 btn-sms1 mt-2 float-right rounded-pill" type="submit"> Request Inspection </button>
            </Link>
            <button className="btn2 btn-sms1 mt-2 float-right rounded-pill" type="submit" onClick={this.openUploadModal} > Upload Documents </button>
            <button className="btn2 btn-sms1 mt-2 float-right rounded-pill" type="submit" onClick={this.openUploadSameDocModal} > Upload Same Documents </button>
          </div>
          <div className="col pt-2  xs={last} " style={{ paddingRight: 30 }}>
            <SearchBar placeholder="Search" value={this.state.searchInput} searchInputHandler={(e) => { this.handleISearch(e) }} searchClick={this.handleSearching} label="Search" btnName="" />
          </div>

        </div>
        <div className="row">
          <div className="col pt-4 centre-alligned">
            {this.state.loading ?
              <Loading />
              :
              <TableComp cols={tableConstants(handleClickTableButton)} data={this.state.tableData} />
            }
          </div>
        </div>

      </div>
    )
  }
}



const mapStateToProps = (state) => ({
  poDetails: state.poDetails,
  qaDocuments: state.poDetails.qaDocuments,
  qaDocumentsByPOLineItemId: state.poDetails.qaDocumentsByPOLineItemId,
  supplier: state.supplier,
  expediting: state.expediting,
  file: state.file
})
export default connect(mapStateToProps, { GetPOLineItemsForSameTemplate, getSupplierPOs, GetAllPoLineItemsByPoId, uploadFileGeneric, postDocumentDetailsForExpediting, GetSameTemplateDetilsByPolineiTemId, uploadVersionFile, uploadFile, requestForVendorApproval, UpdateDocIdForMultipleStagesByPOLineItemId, GetDocumentsForQA, getQADocumentsByParams, postQADocumentForPOLineitemID })(Dashboard)
